import { get } from 'lodash'
import config from '../../config'

const useConfig = () => {

    return {
        name: get(config, 'name', ''),
        version: get(config, 'version', ''),
        env: get(config, 'env', 'u'),
    }
}

export default useConfig